import { motion } from 'framer-motion';
import { MessageSquare, Palette, Calendar } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const icons = [MessageSquare, Palette, Calendar];

export const ProcesoTrabajo = () => {
  const { t } = useLanguage();

  return (
    <section id="proceso" className="bg-[#111111] py-16 sm:py-20 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="mb-10 text-center sm:mb-12"
        >
          <h2
            className="text-4xl sm:text-5xl lg:text-6xl font-light text-[#F5F5F5] tracking-tight"
            style={{ fontFamily: 'Playfair Display, serif' }}
            data-testid="proceso-title"
          >
            {t.proceso.title}
          </h2>
        </motion.div>

        <div className="mx-auto max-w-4xl space-y-8 sm:space-y-10">
          {t.proceso.steps.map((step, index) => {
            const Icon = icons[index];
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="group flex items-start gap-4 sm:gap-6"
                data-testid={`proceso-step-${index + 1}`}
              >
                <div className="flex flex-col items-center gap-4 flex-shrink-0">
                  <div className="flex h-14 w-14 items-center justify-center bg-[#1C1C1C] transition-colors duration-300 group-hover:bg-[#E5E5E5] sm:h-16 sm:w-16">
                    <Icon className="h-6 w-6 text-[#E5E5E5] transition-colors duration-300 group-hover:text-[#0B0B0B] sm:h-7 sm:w-7" />
                  </div>
                  <span className="text-3xl font-light text-[#1C1C1C] transition-colors duration-300 group-hover:text-[#E5E5E5] sm:text-4xl">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                </div>

                <div className="flex-1 pt-1 sm:pt-3">
                  <h3 className="mb-2 text-xl font-light tracking-tight text-[#F5F5F5] sm:text-2xl">
                    {step.title}
                  </h3>
                  <p className="max-w-2xl text-sm leading-6 text-[#9CA3AF] sm:text-base">
                    {step.description}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
